package com.castly.shared.dto

import kotlinx.serialization.Serializable

@Serializable
data class AuthorDto(
    val id: Int,
    val name: String,
    val biography: String? = null,
    val audiobookCount: Int? = null,
    val createdAt: String? = null,
    val updatedAt: String? = null
)

@Serializable
data class CreateAuthorRequest(
    val name: String,
    val biography: String? = null
)

@Serializable
data class UpdateAuthorRequest(
    val name: String? = null,
    val biography: String? = null
)

@Serializable
data class AuthorListResponse(
    val authors: List<AuthorDto>,
    val total: Int,
    val page: Int,
    val pageSize: Int
)

@Serializable
data class AuthorDetailResponse(
    val author: AuthorDto,
    val audiobooks: List<AudiobookDto>
)

@Serializable
data class MergeAuthorRequest(
    val sourceId: Int,
    val targetId: Int
)
